var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: function() {
            this$1.isOpen = false
          },
          expression: "() => {this.isOpen = false}"
        }
      ],
      staticClass: "many-select"
    },
    [
      _c(
        "div",
        {
          staticClass: "many-select__display",
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [
          _c("div", { staticClass: "many-select__display-text" }, [
            _vm._v("\n            " + _vm._s(_vm.values) + "\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "many-select__display-arrow" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "9",
                  height: "5",
                  viewBox: "0 0 9 5",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d:
                      "M3.70472 4.68313C3.9177 4.8877 4.19891 5 4.50037 5C4.80109 5 5.0838 4.8877 5.29528 4.68313L8.78009 1.23404C9.0733 0.951504 9.0733 0.494439 8.78009 0.211902C8.48763 -0.0706341 8.01294 -0.0706341 7.71972 0.211902L4.50037 3.40564L1.28028 0.211902C0.987064 -0.0706341 0.513123 -0.0706341 0.21991 0.211902C-0.0733033 0.494439 -0.0733033 0.951504 0.21991 1.23404L3.70472 4.68313Z",
                    fill: "black"
                  }
                })
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade-filter" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen"
              }
            ],
            staticClass: "many-select__content"
          },
          _vm._l(_vm.options, function(option) {
            return _c(
              "div",
              { key: option.id, staticClass: "many-select__item" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: option.checked,
                      expression: "option.checked"
                    }
                  ],
                  staticClass: "many-select__input",
                  attrs: {
                    type: "checkbox",
                    name: _vm.name + "[" + option.id + "]",
                    id: _vm.name + "-" + option.id,
                    disabled: option.disabled
                  },
                  domProps: {
                    checked: _vm.isChecked(option),
                    checked: Array.isArray(option.checked)
                      ? _vm._i(option.checked, null) > -1
                      : option.checked
                  },
                  on: {
                    change: function($event) {
                      var $$a = option.checked,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(option, "checked", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              option,
                              "checked",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(option, "checked", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                option.objectName
                  ? _c(
                      "label",
                      {
                        staticClass: "many-select__label",
                        attrs: { for: _vm.name + "-" + option.id }
                      },
                      [
                        _vm._v(
                          _vm._s(option.title) +
                            ", " +
                            _vm._s(option.objectName.toLowerCase()) +
                            "\n                "
                        )
                      ]
                    )
                  : _c(
                      "label",
                      {
                        staticClass: "many-select__label",
                        attrs: { for: _vm.name + "-" + option.id }
                      },
                      [
                        _vm._v(
                          _vm._s(option.title) +
                            ", " +
                            _vm._s(option.objectName.toLowerCase()) +
                            "\n                "
                        )
                      ]
                    )
              ]
            )
          }),
          0
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }